import { render, staticRenderFns } from "./AuthLayout.pug?vue&type=template&id=31b052ca&scoped=true&lang=pug&"
import script from "./AuthLayout.js?vue&type=script&lang=js&"
export * from "./AuthLayout.js?vue&type=script&lang=js&"
import style0 from "./AuthLayout.sass?vue&type=style&index=0&id=31b052ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b052ca",
  null
  
)

component.options.__file = "AuthLayout.vue"
export default component.exports